import React, { useState, useEffect } from 'react';

interface CounterProps {
    start: number;
    end: number;
}

export const Counter: React.FC<CounterProps> = ({ start, end }) => {
    const [count, setCount] = useState(start);
    const increment = Math.ceil((end - start) / 50); // Increment more rapidly

    useEffect(() => {
        if (count < end) {
            const timer = setInterval(() => {
                setCount((prevCount) => Math.min(prevCount + increment, end));
            }, 1000 / 60); // Update every 1/60th of a second
            return () => clearInterval(timer);
        }
    }, [count, end, increment]);

    return <div>{count.toLocaleString()}</div>;
};
